import  {baseActions}  from "./base.actions";

export const provinceActions = {
   
    gets,
    get,
    
};


function gets() {
    return baseActions.getall('province');
}

function get(id)
{
    return baseActions.get('province',id);
}
